"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const utilities_1 = require("@kalkulacka-one/design-system/utilities");
const react_1 = require("@headlessui/react");
const class_variance_authority_1 = require("class-variance-authority");
const react_2 = __importDefault(require("react"));
const InputVariants = (0, class_variance_authority_1.cva)([
    "ko:w-full",
    "ko:border ko:border-neutral",
    "ko:rounded-2xl ko:rounded-br-none",
    "ko:placeholder:text-base ko:placeholder:font-sans ko:placeholder:text-neutral",
    "ko:data-hover:border-neutral-hover",
    "ko:data-disabled:placeholder:text-neutral-disabled ko:data-disabled:border-neutral-disabled ko:data-disabled:text-neutral-disabled",
], {
    variants: {
        variant: {
            default: "ko:p-4",
            icon: "ko:pl-14 ko:p-4",
        },
    },
});
function InputComponent({ children, variant, ...props }, ref) {
    const hasIcon = children != null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "ko:relative", children: [hasIcon && (0, jsx_runtime_1.jsx)("div", { className: "ko:absolute ko:left-4 ko:top-1/2 ko:-translate-y-1/2", children: children }), (0, jsx_runtime_1.jsx)(react_1.Input, { ...props, ref: ref, className: (0, utilities_1.twMerge)(InputVariants({ variant: hasIcon ? "icon" : "default" })) })] }));
}
exports.Input = react_2.default.forwardRef(InputComponent);
